// A scoring preset is an admin-managed named ruleset (GET /api/presets). Members
// pick one when proposing a round; both the picker and the admin manager show the
// same plain-English summary formatted from the numbers the API returns. The shape
// lives in core/types (Preset); re-exported here so existing imports keep working.
import type { Preset } from '../core/types';
export type { Preset };

/** e.g. "20 points · up to 20 per track · no down-votes · veto at 50%". */
export function summarise(p: Pick<Preset, 'budget' | 'track_min' | 'track_max' | 'negative_multiplier' | 'veto_threshold' | 'veto_threshold_pct' | 'veto_enabled'>): string {
  const parts = [`${p.budget} points`, `up to ${p.track_max} per track`];
  parts.push(p.track_min < 0 ? `down-votes cost ${p.negative_multiplier}×` : 'no down-votes');
  // Prefer the % (the setting owners edit); fall back to the live count if that's all we have.
  parts.push(p.veto_enabled ? (p.veto_threshold_pct != null ? `veto at ${p.veto_threshold_pct}%` : `veto at ${p.veto_threshold}`) : 'no veto');
  return parts.join(' · ');
}

export const SAMPLE_PRESETS: Preset[] = [
  { ruleset_id: 1, name: 'Standard', budget: 20, track_min: 0, track_max: 20, negative_multiplier: 2, veto_threshold: 5, veto_penalty: 10, popularity_bonus: 3, popularity_tie_bonus: 1, veto_enabled: true },
  { ruleset_id: 2, name: 'Relaxed', budget: 30, track_min: -3, track_max: 10, negative_multiplier: 2, veto_threshold: 4, veto_penalty: 8, popularity_bonus: 3, popularity_tie_bonus: 1, veto_enabled: true },
  { ruleset_id: 3, name: 'Ruthless', budget: 15, track_min: -5, track_max: 15, negative_multiplier: 3, veto_threshold: 3, veto_penalty: 12, popularity_bonus: 4, popularity_tie_bonus: 2, veto_enabled: false },
];
